import React from 'react';
import { RefinementList } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import capitalize from 'lodash/capitalize';
import orderBy from 'lodash/orderBy';

import messages from 'Components/Search/SearchMessages';
import filterMessages from 'Components/Search/FilterMessages';

export default function ListFilter({
  attribute,
  translate,
  facets,
  allowedValues,
  operator,
  long,
  title,
  searchable,
}) {
  const { formatMessage } = useIntl();

  const transformItems = (items) => {
    const allowedItems = items.filter(
      item => !allowedValues.length || allowedValues.includes(item.label),
    );

    if (translate || facets.length) {
      const formattedItems = allowedItems.map((item) => {
        let label = item.label;

        let formatLabel = true;
        if (label === 'epicgames' || label === 'uplay' || label === 'playstation' || label === 'utalk' || label === 'switch' || label === 'eaplay' || label === 'oculus') {
          formatLabel = false;
        }
        if (label === 'epicgames') label = 'Epic Games';
        if (label === 'uplay') label = 'Ubisoft Connect';
        if (label === 'playstation') label = 'PlayStation';
        if (label === 'utalk') label = 'uTalk';
        if (label === 'switch') label = 'Nintendo Switch';
        if (label === 'eaplay') label = 'EA Play';
        if (label === 'oculus') label = 'Meta';

        if (label === 'graphic-novel') label = 'Graphic novel';

        if (translate && filterMessages[item.label.toLowerCase()]) {
          label = formatMessage(filterMessages[item.label.toLowerCase()]);
        }
        if (attribute !== 'drm' || (formatLabel && attribute === 'drm')) label = label === label.toUpperCase() ? label : capitalize(label);

        if (facets.length) {
          const match = facets.find(f => f.slug === item.label);

          if (match) {
            label = match.name;
          } else {
            label = capitalize(label).replace(/-/g, ' ');
          }
        }

        return {
          label,
          value: item.value,
          count: item.count,
          isRefined: item.isRefined,
          _highlightResult: { label: { value: label } }, // Replace existing highlight with plain string
        };
      });
      return orderBy(formattedItems, 'count', 'desc');
    }

    return allowedItems;
  };

  return (
    <RefinementList
      operator={operator}
      showMore={long}
      searchable={searchable && long && window.locale === 'en'}
      attribute={attribute}
      limit={8}
      showMoreLimit={window.locale === 'en' ? 50 : (facets.length || 20)}
      translations={{
        placeholder: formatMessage(messages.placeholder, { title }),
        showMore: expanded =>
          (expanded ? formatMessage(messages.showLess) : formatMessage(messages.showMore)),
      }}
      transformItems={transformItems}
    />
  );
}

ListFilter.propTypes = {
  attribute: PropTypes.string.isRequired,
  operator: PropTypes.string,
  long: PropTypes.bool,
  searchable: PropTypes.bool,
  translate: PropTypes.bool,
  allowedValues: PropTypes.arrayOf(PropTypes.string),
  facets: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
};

ListFilter.defaultProps = {
  operator: 'or',
  long: false,
  searchable: true,
  translate: false,
  allowedValues: [],
  facets: [],
  title: '',
};
